module.exports = __webpack_public_path__ + "components/affiliate-fillers/booking/static/filler@2-94b8e1d41901ae6d17ffad7cc4371965.jpg";